__turbopack_context__.v({
  "cta": "go2NwW_cta",
  "footer": "go2NwW_footer",
  "fullwidth": "go2NwW_fullwidth",
  "reviews": "go2NwW_reviews",
  "start-simulation-card": "go2NwW_start-simulation-card",
  "start-simulation-card-form": "go2NwW_start-simulation-card-form",
  "start-simulation-card-wrapper": "go2NwW_start-simulation-card-wrapper",
});
